/* assets/tg-pdp-bundle.js - build artefact, do not hand-edit.
   Byte-faithful concatenation of the three product-page scripts that used to
   load as three separate deferred requests, in their ORIGINAL order:
   tg-buybox.js -> tg-default-variant.js -> tg-option-label-sync.js.
   Each source is a self-contained IIFE (or a top-level DOMContentLoaded
   listener) that ends in a semicolon, so concatenation introduces no ASI
   hazard and no shared scope. Loaded with the same defer attribute the three
   originals carried. The originals are still in assets/ and are now
   unreferenced; edit those and rebuild, or edit the matching section below. */

/* ==========================================================================
   BUNDLED 1/3: assets/tg-buybox.js
   ========================================================================== */
/* True Gear buy box (ported 22 Aug 2026 from the sister-brand reference theme's buy-box script,
   v8.3, renamed tg-). All buy-box JS: right-side drawer, commonly-bought-with
   add/remove, variant selected-state, sticky ATC, variant price
   sync, cart notification toast, and the "Chat to Tim & Angel" expander.
   Loaded deferred from snippets/product-form.liquid. Progressive enhancement
   only; never touches the product form submit path.

   Dropped from the reference source: the "inc GST" price-label injector (True
   Gear states GST inclusion elsewhere) and the JS-injected call bar (True
   Gear's call bar is rendered as plain Liquid in product-form.liquid, so no
   DOM-insertion script is needed). */

(function () {
  var root = document.querySelector('[data-tg-ob]'); if (!root) return;
  /* Header cart badge. THIS theme renders the number from the
     data-header-cart-count ATTRIBUTE via CSS (the span's textContent is empty)
     and shows/hides the bubble with a .visible class, so an AJAX add has to set
     both. The textContent writes below are kept for other themes' markup
     ([data-cart-count] / .cart-count / .cart-count-bubble), which this theme
     does not use. */
  function setCartCount(n) {
    document.querySelectorAll('.site-header-cart--count, [data-header-cart-count]').forEach(function (el) {
      el.setAttribute('data-header-cart-count', n > 0 ? String(n) : '');
      el.classList.toggle('visible', n > 0);
    });
    document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble').forEach(function (el) { el.textContent = n; });
  }
  function syncCart() { fetch('/cart.js', {headers: {Accept: 'application/json'}}).then(function(r){return r.json();}).then(function(c){setCartCount(c.item_count);document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart:c}}));}).catch(function(){}); }
  /* Cross-sell adds are silent otherwise: the row button flips to "Added" but
     nothing else on the page moves, so it reads as broken. Fire the toast (the
     listener lives in the cart-notification block). The main ATC does NOT use
     this path - the theme's own native banner covers that one. */
  function announceAdd(btn) {
    var row = btn.closest ? btn.closest('.tg-ob__row') : null;
    var nameEl = row ? row.querySelector('.tg-ob__name') : null;
    var title = nameEl ? (nameEl.textContent || '').trim() : '';
    document.dispatchEvent(new CustomEvent('tg:cart-added', {bubbles:true, detail:{title:title}}));
  }
  root.querySelectorAll('[data-tg-ob-add]').forEach(function(btn){btn.addEventListener('click',function(e){e.stopPropagation();var id=parseInt(btn.getAttribute('data-id'),10); if(!id||btn.getAttribute('data-busy')==='1')return; var wasAdded=btn.classList.contains('is-added'); btn.setAttribute('data-busy','1'); btn.disabled=true; btn.textContent=wasAdded?'Removing':'Adding'; if(!wasAdded){fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})}).then(function(r){if(!r.ok)throw new Error();return r.json();}).then(function(d){var key=(d.items&&d.items[0])?(d.items[0].key||''):'';if(key)btn.setAttribute('data-line-key',key);btn.setAttribute('data-busy','0');btn.disabled=false;btn.classList.add('is-added');btn.setAttribute('aria-pressed','true');btn.textContent='Added';announceAdd(btn);syncCart();}).catch(function(){btn.setAttribute('data-busy','0');btn.disabled=false;btn.textContent='Add';});}else{var lineKey=btn.getAttribute('data-line-key');var payload=lineKey?{id:lineKey,quantity:0}:{id:id,quantity:0};fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)}).then(function(r){if(!r.ok)throw new Error();return r.json();}).then(function(){btn.setAttribute('data-busy','0');btn.disabled=false;btn.classList.remove('is-added');btn.setAttribute('aria-pressed','false');btn.textContent='Add';btn.removeAttribute('data-line-key');syncCart();}).catch(function(){btn.setAttribute('data-busy','0');btn.disabled=false;btn.textContent='Added';});}});});
  function closeAll() { root.querySelectorAll('[data-tg-ob-modal]:not([hidden])').forEach(function (m) { m.setAttribute('hidden', ''); }); document.documentElement.classList.remove('tg-ob-modal-lock'); }
  root.querySelectorAll('[data-tg-ob-open]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-tg-ob-add')) return;
      var m = root.querySelector('[data-tg-ob-modal="' + b.getAttribute('data-tg-ob-open') + '"]');
      if (!m) return;
      closeAll();
      m.removeAttribute('hidden');
      document.documentElement.classList.add('tg-ob-modal-lock');
    });
  });
  root.querySelectorAll('[data-tg-ob-close]').forEach(function (b) { b.addEventListener('click', closeAll); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  root.querySelectorAll('[data-tg-ob-modal-add]').forEach(function (b) {
    b.addEventListener('click', function () {
      /* Resolve the row by its INDEX, not by variant id. Since 31 Aug 2026 a
         multi-variant cross-sell row rewrites its own data-id every time the
         <select> changes, so the old [data-tg-ob-add][data-id="..."] lookup
         went stale the moment anyone touched the dropdown and the modal's
         "Add to cart" quietly did nothing. */
      var idx = b.getAttribute('data-target-row');
      var rowEl = idx ? root.querySelector('.tg-ob__row[data-tg-ob-row="' + idx + '"]') : null;
      var rowBtn = rowEl ? rowEl.querySelector('[data-tg-ob-add]') : null;
      if (!rowBtn || rowBtn.disabled) return;
      if (!rowBtn.classList.contains('is-added')) rowBtn.click();
      b.textContent = 'Added';
      setTimeout(closeAll, 650);
    });
  });

  /* ===== Cross-sell variant selector (31 Aug 2026) =====
     Rows for cross-sell products with more than one variant render a <select>;
     single-variant rows render none, so they behave exactly as they always did.

     SCOPE. Every price write below is confined to the row it belongs to (or to
     that row's own modal). This page has previous form: an unscoped
     document.querySelectorAll('.price--main .money') once stamped the buy box's
     price onto every recommendation card on the page. Nothing here ever queries
     above .tg-ob__row.

     The <select> has no name attribute (it sits inside the product form, which
     superstore.js serialises on submit) and matches none of the selectors the
     buy box variant-price sync listens on, so it cannot move the main price. */
  root.querySelectorAll('[data-tg-ob-variant]').forEach(function (sel) {
    var row = sel.closest ? sel.closest('.tg-ob__row') : null;
    if (!row) return;
    var addBtn = row.querySelector('[data-tg-ob-add]');
    if (!addBtn) return;
    var priceEl = row.querySelector('[data-tg-ob-price]');
    var idx = row.getAttribute('data-tg-ob-row');
    var modal = idx ? root.querySelector('[data-tg-ob-modal="' + idx + '"]') : null;
    var modalPriceEl = modal ? modal.querySelector('[data-tg-ob-modal-price]') : null;
    var addLabel = addBtn.getAttribute('aria-label') || '';

    function applySelection() {
      var opt = sel.options[sel.selectedIndex];
      if (!opt) return;
      var price = opt.getAttribute('data-tg-ob-price-text') || '';
      if (price) {
        if (priceEl) priceEl.textContent = price;
        if (modalPriceEl) modalPriceEl.textContent = price;
      }
      if (addBtn.getAttribute('data-id') !== opt.value) {
        /* A different variant is selected, so this button no longer stands for
           the cart line it may have added. Reset it rather than leave "Added"
           sitting over a variant that is not in the cart. */
        addBtn.setAttribute('data-id', opt.value);
        addBtn.removeAttribute('data-line-key');
        addBtn.setAttribute('data-busy', '0');
        addBtn.classList.remove('is-added');
        addBtn.setAttribute('aria-pressed', 'false');
        addBtn.textContent = 'Add';
      }
      /* Availability. Sold-out options are already rendered disabled so they
         cannot be picked by hand; this is the second gate, for anything that
         sets the value programmatically. */
      var soldOut = !!opt.disabled;
      addBtn.disabled = soldOut;
      addBtn.classList.toggle('is-soldout', soldOut);
      if (soldOut) {
        addBtn.textContent = 'Sold out';
        addBtn.setAttribute('aria-label', 'Sold out');
      } else if (addLabel) {
        addBtn.setAttribute('aria-label', addLabel);
      }
    }

    sel.addEventListener('change', applySelection);
    /* A back/forward restore can hand the select a value the markup did not
       render as selected, so reconcile once on load. */
    applySelection();
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  /* On PRODUCT pages only, demote any stray h1 so the product title is the sole h1. */
  if (document.querySelector('h1.product-title')) {
    document.querySelectorAll('h1:not(.product-title)').forEach(function (h) { var h2 = document.createElement('h2'); for (var i = 0; i < h.attributes.length; i++) { h2.setAttribute(h.attributes[i].name, h.attributes[i].value); } h2.innerHTML = h.innerHTML; h.parentNode.replaceChild(h2, h); });
  }

  /* Right-side drawer (assurance tiles + price beat + quote + finder). Move it
     (and its backdrop) to <body> so it escapes any buy-box stacking context and
     sits above the header. */
  (function () {
    var back = document.querySelector('.tg-drawer-back');
    var drawer = document.querySelector('.tg-drawer');
    if (!back || !drawer) return;
    if (back.parentNode !== document.body) document.body.appendChild(back);
    if (drawer.parentNode !== document.body) document.body.appendChild(drawer);
    var panels = drawer.querySelectorAll('.tg-drawer__panel');
    function openPanel(key) {
      /* Resolve the target BEFORE touching any panel. The old version cleared
         is-active off every panel first and only then bailed when nothing
         matched, so an openPanel('') call blanked the whole drawer. */
      if (!key) return;
      var target = null;
      panels.forEach(function (p) { if (p.getAttribute('data-panel') === key) target = p; });
      if (!target) return;
      panels.forEach(function (p) { p.classList.toggle('is-active', p === target); });
      /* The finder panel embeds /pages/power-station-finder, whose own media
         queries key off the VIEWPORT not the container, so it renders its full
         desktop layout. Widen the drawer for that panel only; every other panel
         keeps the standard narrow width. */
      drawer.classList.toggle('tg-drawer--wide', key === 'finder');
      back.classList.add('is-open'); drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); drawer.removeAttribute('inert');
      document.documentElement.classList.add('tg-ob-modal-lock');
    }
    function closeDrawer() { back.classList.remove('is-open'); drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); drawer.setAttribute('inert', ''); document.documentElement.classList.remove('tg-ob-modal-lock'); }
    /* Only real triggers open a panel. The drawer itself carries a bare
       data-tg-drawer attribute, so without this guard every click INSIDE the
       drawer (a quiz answer, a form field) bubbled up and re-ran openPanel with
       an empty key. */
    document.querySelectorAll('[data-tg-drawer]').forEach(function (c) {
      if (c === drawer) return;
      var key = c.getAttribute('data-tg-drawer');
      if (!key) return;
      c.addEventListener('click', function () { openPanel(key); });
    });
    document.querySelectorAll('[data-tg-open-quote]').forEach(function (b) { b.addEventListener('click', function () { openPanel('quote'); var f = drawer.querySelector('.tg-drawer__panel.is-active input:not([type=hidden])'); if (f) setTimeout(function(){ f.focus({preventScroll:true}); }, 320); }); });
    back.addEventListener('click', closeDrawer);
    drawer.querySelectorAll('[data-tg-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  })();

  /* "Got questions? Chat to Tim & Angel" expander (27 Aug 2026). Replaced the
     tel: call bar and its "or text us" sub-link with one trigger that reveals a
     Call / Text pair.

     Deliberately self-contained: it touches nothing the drawer, cross-sell,
     sticky-ATC, cart-count or toast blocks own, and it reads its panel from the
     trigger's own aria-controls rather than a hardcoded id, so the markup stays
     the single source of truth for the pairing.

     aria-expanded and the panel's `hidden` attribute are flipped together and
     are the ONLY state - there is no animation and no state class, so a screen
     reader and a sighted user always agree about whether the panel is open.
     preventDefault is belt-and-braces on top of the trigger's type="button":
     that attribute is what actually stops a form submit, and it is asserted in
     the Liquid, not here. */
  (function () {
    var trigger = document.querySelector('[data-tg-chat-toggle]');
    if (!trigger) return;
    var panelId = trigger.getAttribute('aria-controls');
    var panel = panelId ? document.getElementById(panelId) : null;
    if (!panel) return;
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (isOpen) { panel.setAttribute('hidden', ''); } else { panel.removeAttribute('hidden'); }
    });
  })();

  /* Variant selected-state (reliable): set a .tg-sel class on the value whose
     radio is actually :checked, since the theme leaves a stale .option-selected
     class on change. */
  (function () {
    var box = document.querySelector('.tg-buybox'); if (!box) return;
    function sync() { box.querySelectorAll('.tg-option-value').forEach(function (v) { var inp = v.querySelector('input[type="radio"]'); v.classList.toggle('tg-sel', !!(inp && inp.checked)); }); }
    sync();
    box.addEventListener('change', function (e) { if (e.target && e.target.matches && e.target.matches('input[type="radio"]')) sync(); });
    box.addEventListener('click', function () { setTimeout(sync, 60); });
  })();

  /* Sticky ATC */
  var sticky = document.querySelector('[data-tg-sticky]'); var mainAtc = document.querySelector('[data-product-atc]');
  if (sticky && mainAtc) {
    var stickyBtn = sticky.querySelector('[data-tg-sticky-atc]'); if (stickyBtn) stickyBtn.addEventListener('click', function () { mainAtc.click(); });
    var show = function (on) { if (on) { sticky.removeAttribute('hidden'); sticky.setAttribute('aria-hidden', 'false'); sticky.classList.add('is-visible'); } else { sticky.classList.remove('is-visible'); sticky.setAttribute('aria-hidden', 'true'); } };
    /* Show once the real ATC button has scrolled fully above the viewport, hide
       again when it comes back. An IntersectionObserver does the work, backed by
       a rAF-throttled scroll/resize fallback plus a visibilitychange re-check:
       IO callbacks (like rAF) are NOT delivered while the tab is hidden, so a
       page scrolled in a background tab would otherwise sit in a stale state. */
    var evaluate = function () { show(mainAtc.getBoundingClientRect().bottom <= 0); };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { entries.forEach(function (e) { show(!e.isIntersecting && e.boundingClientRect.top < 0); }); }, {threshold: 0}).observe(mainAtc);
    }
    var stickyTick = false;
    var onStickyScroll = function () { if (stickyTick) return; stickyTick = true; window.requestAnimationFrame(function () { stickyTick = false; evaluate(); }); };
    window.addEventListener('scroll', onStickyScroll, {passive: true});
    window.addEventListener('resize', onStickyScroll, {passive: true});
    document.addEventListener('visibilitychange', function () { if (!document.hidden) evaluate(); });
    evaluate();
    /* The mirrored price reads from THIS product's own price block. Resolve it
       through the product-details container rather than document-wide: a bare
       .product-pricing query would happily latch onto a product card's price
       block if one ever rendered ahead of the buy box. */
    var priceDetails = document.querySelector('[data-product-details]') || document.querySelector('.product-details');
    var priceSource = priceDetails ? priceDetails.querySelector('.product-pricing') : null; var stickyPrice = sticky.querySelector('[data-tg-sticky-price]');
    if (priceSource && stickyPrice) { var sync = function () { var node = priceSource.querySelector('.price--main'); if (!node) return; var txt = (node.textContent || '').replace(/\s+/g, ' ').trim(); if (txt) stickyPrice.textContent = txt; }; sync(); new MutationObserver(sync).observe(priceSource, {childList: true, subtree: true, characterData: true}); }
  }

  /* ===== Add to Cart button structure guard (31 Aug 2026) =====
     superstore.js ProductDetails._updateButton() sets the Add to Cart label
     with jQuery .text() on the BUTTON element itself. jQuery's text setter
     writes textContent, which deletes every child node, so a single variant
     switch flattened the button to one bare text node and took the
     .atc-button--text span and the .atc-button--icon spinner with it. Without
     the span the theme's own .processing rules have nothing to fade and nothing
     to spin, so every later add-to-cart ran with no feedback at all.

     The ARROW is not repaired here - it is a ::after pseudo-element in
     assets/tg-pdp-bundle.css precisely so that no script has to. This observer
     exists only for the two real child nodes.

     Loop safety: the callback's first act is to check for
     [data-product-atc-text]. Our own rebuild puts that back, so the mutation we
     cause returns immediately on the next pass. There is no re-entrancy flag
     because there is no re-entrant path. Scope is the button and childList
     only - not subtree, not the document. */
  (function () {
    var atc = document.querySelector('.tg-buybox [data-product-atc]');
    if (!atc || !('MutationObserver' in window)) return;
    var spinner = atc.querySelector('.atc-button--icon');
    var spinnerHTML = spinner ? spinner.outerHTML : '';
    function restore() {
      if (atc.querySelector('[data-product-atc-text]')) return;
      var label = (atc.textContent || '').trim();
      if (!label) return;
      atc.innerHTML = '<span class="atc-button--text" data-product-atc-text></span>' + spinnerHTML;
      var textEl = atc.querySelector('[data-product-atc-text]');
      if (textEl) textEl.textContent = label;
    }
    new MutationObserver(restore).observe(atc, {childList: true});
    restore();
  })();

  /* Variant price sync */
  (function () {
    function formatPrice(cents) { var dollars = (cents / 100); return '$' + dollars.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    /* SCOPE. Every write below is confined to this product's own buy box.
       .price--main and .money are SHARED classes - the async "Shop Similar
       Products" cards and any complementary-products block use exactly the same
       markup - so the old document-wide querySelectorAll wrote the buy box's
       price into every card on the page.

       buyBox() is the product-details column (price block + form + sticky bar);
       recommendation cards render in their own section outside it. priceBox()
       narrows further to the buy box's .product-pricing wrapper, so a
       complementary-products card rendered INSIDE the details column is out of
       reach too.

       Both are resolved on every call, never cached at DOMContentLoaded: the
       cards arrive later from /recommendations/products, and this stays correct
       for a variant change after they land because they are out of scope, not
       because anything pins them back. */
    function buyBox() { return document.querySelector('[data-product-details]') || document.querySelector('.product-details'); }
    function priceBox() { var box = buyBox(); return box ? box.querySelector('.product-pricing') : null; }
    function updateFromVariant(variant) { if (!variant) return; var box = buyBox(); if (!box) return; var prices = priceBox(); var formatted = formatPrice(variant.price); box.querySelectorAll('[data-product-price-text]').forEach(function(el){ el.textContent = formatted; }); if (prices) prices.querySelectorAll('.price--main .money').forEach(function(el){ el.textContent = formatted; }); var stickyPrice = box.querySelector('[data-tg-sticky-price]'); if (stickyPrice) stickyPrice.textContent = formatted; }
    var productData = null;
    function ensureProductData() { if (productData) return Promise.resolve(productData); return fetch(window.location.pathname + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (data) { productData = data; return data; }); }
    function currentVariantId() { var hidden = document.querySelector('form[action*="/cart/add"] input[name="id"]'); if (hidden && hidden.value) return hidden.value; var sel = document.querySelector('select[data-variants]'); return sel ? sel.value : null; }
    function sync() { ensureProductData().then(function (data) { var id = currentVariantId(); if (!id || !data || !data.variants) return; for (var i = 0; i < data.variants.length; i++) { if (String(data.variants[i].id) === String(id)) { updateFromVariant(data.variants[i]); return; } } }).catch(function () {}); }
    document.addEventListener('change', function (e) { if (!e.target) return; var isVariantInput = e.target.matches && (e.target.matches('input[name="id"], input[name^="options"], select[name^="options"], select[data-variants], [data-product-option]') || (e.target.closest && e.target.closest('variant-radios, variant-selects, .product-form__input'))); if (!isVariantInput) return; setTimeout(sync, 50); });
    var hiddenId = document.querySelector('form[action*="/cart/add"] input[name="id"]'); if (hiddenId && 'MutationObserver' in window) { new MutationObserver(sync).observe(hiddenId, { attributes: true, attributeFilter: ['value'] }); }
  })();

  /* Cart notification. CROSS-SELL ADDS ONLY - see the main-ATC note below. */
  (function () {
    var notif = document.querySelector('[data-tg-cart-notification]'); if (!notif) return;
    var productEl = notif.querySelector('[data-tg-cart-notification-product]');
    var dismissBtn = notif.querySelector('[data-tg-cart-notification-dismiss]');
    var hideTimer = null;
    /* Keep the toast clear of the sticky site header. The header is
       position:sticky at z-index 700 and its height CHANGES with scroll -
       announcement bar + utility bar + main header at the top of the page, just
       the main header once scrolled - so the old hardcoded top:1.5rem in
       tg-pdp.css left the "Added to cart" heading sliced in half by the navy
       header bar. Measure the header's live bottom edge on every show (and
       again while the toast is on screen, in case the page is scrolled under
       it) and publish it as --tg-toast-top, which tg-pdp.css reads via
       top:var(--tg-toast-top,1.5rem). No header on the page falls back to the
       same 24px the stylesheet uses.

       Two things worth knowing about the measurement:

       The section-group class carries a LAYOUT SUFFIX in this theme
       (shopify-section-group-header-group-traditional), so an exact-match
       .shopify-section-group-header-group selector finds nothing and the toast
       silently falls back to 24px - straight back into the bug. Match on the
       prefix instead, and keep .site-header-wrapper as a second net.

       Take the LARGEST bottom edge across the whole group rather than one
       element's. At the top of the page the announcement and utility bars are
       static and stack above the sticky header, so the sticky header's own
       bottom already includes them; once scrolled those bars have scrolled off
       and report negative bottoms, so the max is the pinned header's height.
       Correct in both states without special-casing either.

       This sets a custom property rather than an inline top on purpose: the
       mobile rule (max-width:600px) sets top:auto and anchors the toast above
       the bottom edge instead, and an inline top would override that and
       stretch the toast between the two edges. */
    var HEADER_SEL = '[class*="shopify-section-group-header-group"], .site-header-wrapper';
    var TOAST_GAP = 12, TOAST_MIN_TOP = 24;
    function headerBottom() {
      var max = 0;
      document.querySelectorAll(HEADER_SEL).forEach(function (el) {
        var b = el.getBoundingClientRect().bottom;
        if (typeof b === 'number' && isFinite(b) && b > max) max = b;
      });
      return max;
    }
    function position() {
      notif.style.setProperty('--tg-toast-top', Math.max(TOAST_MIN_TOP, Math.round(headerBottom() + TOAST_GAP)) + 'px');
    }
    var posTick = false;
    function reposition() { if (posTick) return; posTick = true; window.requestAnimationFrame(function () { posTick = false; if (notif.classList.contains('is-visible')) position(); }); }
    window.addEventListener('scroll', reposition, {passive: true});
    window.addEventListener('resize', reposition, {passive: true});
    function show() { position(); notif.classList.add('is-visible'); if (hideTimer) clearTimeout(hideTimer); hideTimer = setTimeout(hide, 4000); }
    function hide() { notif.classList.remove('is-visible'); if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; } }
    if (dismissBtn) dismissBtn.addEventListener('click', hide);
    /* MAIN ADD TO CART: deliberately NOT handled here (28 Aug 2026).

       There used to be a document-level submit listener on
       form[action*="/cart/add"] that showed this toast. It has been removed
       because the theme's OWN notification already covers that path: a main ATC
       submit makes superstore.js clone SECTION.atc-banner--container out of the
       [data-templates] container and render it live, with a checkmark, the
       product image, quantity x price, the cart subtotal, a VIEW CART button
       and a direct CHECKOUT button. Both firing meant two notifications on
       screen at once. Tim's call is to keep the native banner on that path - it
       shows the subtotal and it goes straight to checkout.

       Suppressed in JS rather than by deleting the toast, on purpose: the
       markup and the CSS are untouched and still needed by the cross-sell path
       below, so this is reversible by restoring one listener.

       Measured before removing it, on this theme and this page: a main ATC
       click fires exactly one submit event on form[action*="/cart/add"] and the
       native banner appears. A cross-sell add fires no submit event at all and
       the native banner never leaves [data-templates]. That asymmetry is the
       whole reason the next listener has to stay. */
    /* Cross-sell ("Commonly bought with") adds go through fetch('/cart/add.js')
       in the block at the top of this file, so no form is submitted and the
       theme's native banner never fires for them - without this toast the row
       button flipping to "Added" would be the only feedback, which is the
       "cross-sell add does nothing" bug it was added to fix. They dispatch
       tg:cart-added instead. Do not remove this one. */
    document.addEventListener('tg:cart-added', function (e) { var t = e.detail && e.detail.title; if (productEl && t) productEl.textContent = t; show(); });
  })();
});

/* Sticky ATC versus the floating vendor widgets (28 Aug 2026).

   Two third-party widgets float at the bottom of every page and both sat on top
   of the sticky Add to Cart bar: the Google Merchant widget
   (#google-merchantwidget-iframe-wrapper, a direct child of <body>, fixed,
   bottom:5px, z-index 2147483647) and the MessageMedia SMS chat bubble
   (mmgp-sms-chat-widget, bottom-right). Raising the bar's own z-index CANNOT
   fix it, because the Google widget already sits at the maximum, so the widgets
   are moved instead and only while the bar is on screen.

   This block publishes two things on <html> and nothing else:
     .tg-sticky-on   present only while the bar is visible
     --tg-sticky-h   the bar's MEASURED height (64px on a phone, 69px on desktop
                     on this theme, so a single hardcoded guess would be wrong at
                     one of them)
   assets/tg-pdp-fixes.css owns every offset and reads both. Nothing here knows
   or cares how far the widgets move.

   Visibility is decided GEOMETRICALLY (the bar has height and is on screen)
   rather than by watching for the .is-visible class, so it stays correct
   whichever code path shows the bar, and it fails safe: if the bar never
   appears the widgets simply never move.

   Deliberately additive. It is a self-contained IIFE appended after everything
   else in this file, it reads the sticky bar but never writes to it, and it
   touches none of the existing blocks. */
(function () {
  var root = document.documentElement;
  var MARK = 'data-tg-widget-lift';
  var bar = null, observed = null;

  function barEl() {
    if (bar && bar.isConnected) return bar;
    bar = document.querySelector('.tg-sticky-atc');
    /* Re-observe if the section ever re-renders and replaces the node. */
    if (bar && bar !== observed && 'MutationObserver' in window) {
      observed = bar;
      new MutationObserver(apply).observe(bar, {attributes: true, attributeFilter: ['class', 'hidden', 'style']});
    }
    return bar;
  }

  /* The chat bubble cannot be reached with plain CSS, and this was measured
     rather than assumed. Its host element is position:fixed but ZERO sized; the
     visible bubble is a .app div inside the host's shadow root which is itself
     position:fixed, so it resolves against the viewport and moving the host does
     nothing at all (verified: host bottom 5px to 120px moved the bubble 0px).
     The shadow root is OPEN, so one rule is appended into it.

     That rule is driven by --tg-chat-lift because custom properties inherit
     THROUGH the shadow boundary, which keeps the offset in the stylesheet and
     leaves no hardcoded numbers here. It uses a transform rather than rewriting
     bottom, so the vendor's own 8px offset stays the single source of truth for
     where the bubble rests, and with --tg-chat-lift unset the rule is a no-op.
     The widget is never hidden, resized or made non-interactive. */
  function armChatWidget() {
    var host = document.querySelector('mmgp-sms-chat-widget');
    if (!host || !host.shadowRoot) return false;
    if (host.shadowRoot.querySelector('style[' + MARK + ']')) return true;
    var st = document.createElement('style');
    st.setAttribute(MARK, '');
    st.textContent = '.app{transform:translateY(calc(-1 * var(--tg-chat-lift, 0px))) !important;}';
    host.shadowRoot.appendChild(st);
    return true;
  }

  var lastH = -1;
  function apply() {
    var el = barEl(), h = 0;
    if (el) {
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.bottom > 0 && r.top < (window.innerHeight || 0)) h = Math.round(r.height);
    }
    if (h === lastH) return;
    lastH = h;
    if (h > 0) {
      root.style.setProperty('--tg-sticky-h', h + 'px');
      root.classList.add('tg-sticky-on');
      armChatWidget();
    } else {
      root.classList.remove('tg-sticky-on');
      root.style.removeProperty('--tg-sticky-h');
    }
  }

  /* Only scroll and resize go through the rAF throttle, because only they fire
     in floods. The bar's own state change and a return to visibility call
     apply() DIRECTLY: requestAnimationFrame does not run while the tab is
     hidden, so routing those two through the throttle would leave tick latched
     true and the widgets stranded until the next frame. */
  var tick = false;
  function schedule() { if (tick) return; tick = true; window.requestAnimationFrame(function () { tick = false; apply(); }); }
  window.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('resize', schedule, {passive: true});
  document.addEventListener('visibilitychange', function () { if (!document.hidden) apply(); });

  /* The chat widget script is deferred until first interaction or a 4s timeout,
     so its host is NOT in the DOM at load. Poll briefly, not forever, so the
     rule is in place before the bar first appears. apply() re-arms it anyway if
     the widget turns up later still. */
  var tries = 0;
  var poll = setInterval(function () { if (armChatWidget() || ++tries > 120) clearInterval(poll); }, 500);

  apply();
})();

/* ==========================================================================
   BUNDLED 2/3: assets/tg-default-variant.js
   ========================================================================== */
/* True Gear default variant preselect (ported 22 Aug 2026 from the sister-brand reference theme's default-variant script, renamed tg-). Currently inert on True Gear (no product
   carries a default_options metafield yet) but kept for parity / future use.
   Why: Shopify derives the pre-selected variant from OPTION VALUE ORDER, so the only
   native way to land on a non-first combination is to reorder the option values. This
   picks the landing combination on the client instead, so option order stays natural
   AND the page can open on the configuration that sells most.
   Reads window.TG_DEFAULT_OPTIONS (would be set per product from a
   custom.default_options metafield, pipe separated, e.g. "20A|Red").
   Skipped entirely when the URL already carries ?variant= so ad, Google Shopping and
   shared deep links always win. Progressive enhancement: fails silently. */
(function () {
  function run() {
    try {
      var wanted = window.TG_DEFAULT_OPTIONS;
      if (!wanted) return;
      if (new URLSearchParams(window.location.search).has('variant')) return;

      var container = document.querySelector('[data-product-options-container]');
      if (!container) return;
      if (container.dataset.tgDefaultApplied) return;

      var values = String(wanted).split('|').map(function (v) { return v.trim(); }).filter(Boolean);
      if (!values.length) return;

      var inputs = container.querySelectorAll('.tg-option-value__input');
      if (!inputs.length) return;

      var targets = [];
      values.forEach(function (val) {
        for (var i = 0; i < inputs.length; i++) {
          if (inputs[i].value === val) { targets.push(inputs[i]); break; }
        }
      });
      if (targets.length !== values.length) return;

      container.dataset.tgDefaultApplied = '1';

      targets.forEach(function (input) {
        if (!input.checked) input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    } catch (e) { /* never block the page */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(run, 60); });
  } else {
    setTimeout(run, 60);
  }
})();

/* ==========================================================================
   BUNDLED 3/3: assets/tg-option-label-sync.js
   ========================================================================== */
/* True Gear chosen-value label re-sync (ported 22 Aug 2026 from the sister-brand reference theme's option-label-sync script, renamed tg-).

   The picker in snippets/product-options.liquid writes each option's chosen value
   from the change event's own target, so it only ever updates the option the shopper
   actually clicked. That is wrong whenever the theme changes a DIFFERENT option for
   them (an unavailable combination forces a different value elsewhere) - the recap
   and price are right, but a stale label would lie.

   This re-reads every option's checked radio after any change inside the picker and
   rewrites all the labels, so what is written always matches what is selected.
   Site-wide and idempotent; it only ever writes text that is already true. */
(function () {
  function syncAll(container) {
    if (!container) return;
    var labels = container.querySelectorAll('[data-selected-option]');
    for (var i = 0; i < labels.length; i++) {
      var index = labels[i].getAttribute('data-selected-option');
      var checked = container.querySelector('.tg-option-value__input[data-product-option="' + index + '"]:checked');
      var next = checked ? checked.value : '';
      if (labels[i].textContent.trim() !== next) labels[i].textContent = next;
    }
  }

  function bind(container) {
    if (!container || container.dataset.tgLabelSyncBound) return;
    container.dataset.tgLabelSyncBound = '1';
    container.addEventListener('change', function () {
      setTimeout(function () { syncAll(container); }, 0);
      setTimeout(function () { syncAll(container); }, 250);
    });
    syncAll(container);
  }

  function boot() {
    document.querySelectorAll('[data-product-options-container]').forEach(bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* True Gear variant dropdown (13 Sep 2026, Tim: options with 2+ values become a dropdown).
   The markup comes from snippets/product-options.liquid; this only wires it up. The radios in
   the fieldset stay the real inputs: choosing an option checks the matching radio and fires
   change, exactly as tg-default-variant.js does, so the theme's variant resolution, price,
   stock and label sync run unchanged. The button re-renders from whichever radio is checked
   after any change in the options container, so if the theme itself moves a selection the
   dropdown follows. On a two-option product the theme disables the radios for values that do
   not exist with the other selection (Thule 3.75m only comes in White Case); those options are
   shown as unavailable here and cannot be chosen, matching the disabled pills. Kept in step in two files: assets/tg-option-label-sync.js (source) and
   the end of assets/tg-pdp-bundle.js (what the product page loads). */
(function () {
  function bind(dd) {
    if (dd.dataset.tgDdBound) return;
    dd.dataset.tgDdBound = '1';
    var fieldset = dd.closest('fieldset') || dd.parentNode;
    var index = dd.getAttribute('data-option-index');
    var btn = dd.querySelector('.tg-dd__btn');
    var list = dd.querySelector('.tg-dd__list');
    if (!btn || !list) return;
    var options = Array.prototype.slice.call(list.querySelectorAll('[role="option"]'));
    if (!options.length) return;

    function radioFor(value) {
      var radios = fieldset.querySelectorAll('.tg-option-value__input[data-product-option="' + index + '"]');
      for (var i = 0; i < radios.length; i++) { if (radios[i].value === value) return radios[i]; }
      return null;
    }
    function render() {
      var checked = fieldset.querySelector('.tg-option-value__input[data-product-option="' + index + '"]:checked');
      if (!checked) return;
      options.forEach(function (o) {
        var r = radioFor(o.getAttribute('data-value'));
        if (r && r.disabled) { o.setAttribute('aria-disabled', 'true'); } else { o.removeAttribute('aria-disabled'); }
        var on = o.getAttribute('data-value') === checked.value;
        o.setAttribute('aria-selected', on ? 'true' : 'false');
        if (!on) return;
        var nm = o.querySelector('.tg-dd__nm'), sub = o.querySelector('.tg-dd__sub'), pr = o.querySelector('.tg-dd__pr');
        var bNm = btn.querySelector('[data-tg-dd-name]'), bSub = btn.querySelector('[data-tg-dd-sub]'), bPr = btn.querySelector('[data-tg-dd-price]');
        if (bNm && nm) bNm.textContent = nm.textContent;
        if (bSub) { bSub.textContent = sub ? sub.textContent : ''; if (sub) { bSub.removeAttribute('hidden'); } else { bSub.setAttribute('hidden', ''); } }
        if (bPr && pr && pr.firstChild) bPr.textContent = pr.firstChild.textContent;
      });
    }
    function setOpen(open) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        list.removeAttribute('hidden');
        var sel = list.querySelector('[aria-selected="true"]') || options[0];
        sel.focus({ preventScroll: true });
        if (sel.scrollIntoView) sel.scrollIntoView({ block: 'nearest' });
      } else {
        list.setAttribute('hidden', '');
      }
    }
    function choose(o) {
      var radio = radioFor(o.getAttribute('data-value'));
      if (!radio || radio.disabled) return;
      setOpen(false);
      btn.focus({ preventScroll: true });
      if (!radio) return;
      if (!radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      render();
    }

    btn.addEventListener('click', function (e) { e.preventDefault(); setOpen(btn.getAttribute('aria-expanded') !== 'true'); });
    btn.addEventListener('keydown', function (e) { if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); setOpen(true); } });
    list.addEventListener('click', function (e) { var o = e.target.closest('[role="option"]'); if (o) choose(o); });
    list.addEventListener('keydown', function (e) {
      var i = options.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); options[Math.min(i + 1, options.length - 1)].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); options[Math.max(i - 1, 0)].focus(); }
      else if (e.key === 'Home') { e.preventDefault(); options[0].focus(); }
      else if (e.key === 'End') { e.preventDefault(); options[options.length - 1].focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (i >= 0) choose(options[i]); }
      else if (e.key === 'Escape') { e.preventDefault(); setOpen(false); btn.focus(); }
      else if (e.key === 'Tab') { setOpen(false); }
    });
    document.addEventListener('click', function (e) { if (btn.getAttribute('aria-expanded') === 'true' && !dd.contains(e.target)) setOpen(false); });
    var container = dd.closest('[data-product-options-container]') || fieldset;
    container.addEventListener('change', function () { setTimeout(render, 0); setTimeout(render, 250); });
    render();
  }
  function boot() { document.querySelectorAll('[data-tg-dd]').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();


/* Stock line + pre-order sync (5 Oct 2026, Tim). product-form.liquid prints one .tg-stockvar block per variant
   (data-tg-stock-v = variant id, data-atc = button label for pre-order variants, empty otherwise). This shows the
   block for the chosen variant and keeps the add-to-cart button (and the sticky bar button) on "Pre-order Now"
   for pre-order variants. The theme's own _updateButton() rewrites the button text to its Add to cart string on
   every variant change, so an observer on the button puts the pre-order label back. Loop-safe: it only writes
   when the text differs. */
(function () {
  var wrap = document.querySelector('[data-tg-stockwrap]'); if (!wrap) return;
  var atc = document.querySelector('.tg-buybox [data-product-atc]');
  var sticky = document.querySelector('[data-tg-sticky-atc]');
  var stickyDefault = sticky ? (sticky.getAttribute('data-default') || 'Add to cart') : '';
  function currentId() { var h = document.querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('select[data-variants]'); return h && h.value ? String(h.value) : ''; }
  function block(id) { return id ? wrap.querySelector('[data-tg-stock-v="' + id + '"]') : null; }
  function labelFix() {
    var b = block(currentId()); var l = b ? (b.getAttribute('data-atc') || '') : '';
    if (atc && l && !atc.disabled) { var t = atc.querySelector('[data-product-atc-text]'); if (t && t.textContent.trim() !== l) t.textContent = l; }
    if (sticky) {
      if (l && atc && !atc.disabled) { if (sticky.textContent !== l) sticky.textContent = l; }
      else if (sticky.textContent === 'Pre-order Now') sticky.textContent = stickyDefault;
    }
  }
  function apply() {
    var id = currentId(); if (!id || !block(id)) return;
    wrap.querySelectorAll('[data-tg-stock-v]').forEach(function (b) { b.hidden = b.getAttribute('data-tg-stock-v') !== id; });
    document.querySelectorAll('[data-tg-ticks-v]').forEach(function (b) { b.hidden = b.getAttribute('data-tg-ticks-v') !== id; });
    labelFix();
  }
  function later() { setTimeout(apply, 60); setTimeout(apply, 350); }
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.matches) return;
    var isVar = t.matches('input[name="id"], input[name^="options"], select[name^="options"], select[data-variants], [data-product-option]') || (t.closest && t.closest('variant-radios, variant-selects, .product-form__input, [data-product-options-container]'));
    if (isVar) later();
  });
  document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('.tg-buybox')) later(); }, true);
  var lastId = currentId();
  setInterval(function () { var id = currentId(); if (id !== lastId) { lastId = id; apply(); } }, 400);
  var hid = document.querySelector('form[action*="/cart/add"] [name="id"]');
  if (hid && 'MutationObserver' in window) new MutationObserver(apply).observe(hid, { attributes: true, attributeFilter: ['value'] });
  if (atc && 'MutationObserver' in window) new MutationObserver(labelFix).observe(atc, { childList: true, subtree: true, characterData: true });
  apply();
})();


/* Waitlist (5 Oct 2026, Tim). When the chosen variant's stock block has data-wl="1" (out of stock and unbuyable) the
   email box above the button is shown, the button reads "Join the waitlist" and is kept enabled, and clicking it (or the
   sticky bar button, or Enter in the email field) subscribes the email to Klaviyo's Back in Stock list instead of adding
   to cart. Klaviyo client endpoint: POST /client/back-in-stock-subscriptions/?company_id=... (202 on success). */
(function () {
  var wrap = document.querySelector('[data-tg-stockwrap]'), box = document.querySelector('[data-tg-waitlist]');
  if (!wrap || !box) return;
  var atc = document.querySelector('.tg-buybox [data-product-atc]'); if (!atc) return;
  var input = box.querySelector('input'), msg = box.querySelector('[data-tg-waitlist-msg]');
  var LABEL = 'Join the waitlist', done = {}, busy = false;
  function currentId() { var h = document.querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('select[data-variants]'); return h && h.value ? String(h.value) : ''; }
  function isWl() { var id = currentId(); var b = id ? wrap.querySelector('[data-tg-stock-v="' + id + '"]') : null; return !!(b && b.getAttribute('data-wl') === '1'); }
  function say(t, cls) { msg.textContent = t || ''; msg.className = 'tg-waitlist__msg' + (cls ? ' ' + cls : ''); }
  function sync() {
    var wl = isWl(); box.hidden = !wl;
    if (!wl) return;
    if (atc.disabled) atc.disabled = false;
    if (atc.classList.contains('disabled')) atc.classList.remove('disabled'); /* guard: remove() on an absent token still queues a class mutation = observer loop */
    var t = atc.querySelector('[data-product-atc-text]'); var want = LABEL;
    if (t && t.textContent.trim() !== want) t.textContent = want;
    var st = document.querySelector('[data-tg-sticky-atc]'); if (st && st.textContent !== want) st.textContent = want;
    if (done[currentId()]) say("You're on the list. We'll email you the moment it's back.", 'is-ok'); else if (msg.classList.contains('is-ok')) say('');
  }
  function join() {
    var id = currentId(), email = (input.value || '').trim();
    if (done[id]) return;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { say('Pop a valid email address in first.', 'is-err'); input.focus(); return; }
    if (busy) return; busy = true; say('Adding you to the list...');
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(box.getAttribute('data-company')), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({ data: { type: 'back-in-stock-subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: email } } }, channels: ['EMAIL'] }, relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + id } } } } })
    }).then(function (r) {
      busy = false;
      if (r.status === 202 || r.status === 200 || r.status === 201) { done[id] = true; sync(); }
      else say("That didn't go through. Try again, or call us on 03 7056 6732.", 'is-err');
    }).catch(function () { busy = false; say("That didn't go through. Try again, or call us on 03 7056 6732.", 'is-err'); });
  }
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest || !isWl()) return;
    if (t.closest('[data-product-atc]')) { e.preventDefault(); e.stopImmediatePropagation(); join(); }
    else if (t.closest('[data-tg-sticky-atc]')) { e.preventDefault(); e.stopImmediatePropagation(); box.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { input.focus(); }, 350); }
  }, true);
  document.addEventListener('submit', function (e) { if (isWl() && e.target && e.target.closest && e.target.contains(atc)) { e.preventDefault(); e.stopImmediatePropagation(); join(); } }, true);
  input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); join(); } });
  if ('MutationObserver' in window) new MutationObserver(sync).observe(atc, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class'] });
  document.addEventListener('change', function () { setTimeout(sync, 80); setTimeout(sync, 400); });
  var last = currentId(); setInterval(function () { var id = currentId(); if (id !== last) { last = id; sync(); } }, 400);
  sync();
})();
